var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LUPE_DROP",
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.781,
    height: 108.591,
    viewBox: "0 0 106.781 108.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #LUPE_DROP .cls-1 {\n        fill: #c5d75d;\n      }\n\n      #LUPE_DROP .cls-2 {\n        fill: #3e4346;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2724",
    "data-name": "Pfad 2724",
    className: "cls-1",
    d: "M40.622,37.621a17.106,17.106,0,1,1-34.21,0c0-9.556,17.107-34.005,17.107-34.005s17.1,24.449,17.1,34.005M31.131,31.99a4.445,4.445,0,1,0,4.394,4.447,4.42,4.42,0,0,0-4.394-4.447",
    transform: "translate(19.772 11.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2725",
    "data-name": "Pfad 2725",
    className: "cls-2",
    d: "M42.937,85.861A42.93,42.93,0,1,1,85.869,42.933,42.981,42.981,0,0,1,42.937,85.861m0-79.735A36.8,36.8,0,1,0,79.743,42.933,36.851,36.851,0,0,0,42.937,6.126",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2726",
    "data-name": "Pfad 2726",
    className: "cls-2",
    d: "M44.58,51.145a6.106,6.106,0,0,1-4.333-1.793L19.979,29.085a6.125,6.125,0,1,1,8.662-8.662L48.913,40.687A6.126,6.126,0,0,1,44.58,51.145",
    transform: "translate(56.076 57.446)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.3c70de8fa3eef51b3c4fdd5e5e7f5365.svg";
export { ForwardRef as ReactComponent };